export const quoteListParams = {
  page: "page",
  search: "search",
  limit: "limit",
  quoteFilter: "quoteFilter",
  clientType: "criteria[clientType]",
  assignedTo: "criteria[assignedTo]",
  lastClientQuote: "criteria[lastClientQuote]",
  variantsFilter: "criteria[variants]",
  createdOrSentBy: "criteria[createdOrSentBy]",
  quoteStatus: "criteria[status]",
  source: "criteria[source]",
  direction: "criteria[direction]",
  myTeamsQuotes: "criteria[myTeamsQuotes]",
  createdAtFrom: "criteria[createdAtFrom]",
  createdAtTo: "criteria[createdAtTo]",
};
